import { globalVariables } from "helper/globalVariables";
import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import "./modules.css";

import Dropdown from "shared/Components/dropdown";
import { dropdowns } from "./Components/constant";
import { Button } from "shared/Components/button";
import Accordion from "shared/Components/accordian";
import { BottomButtons } from "shared/Components/bottomButtons";
import { LeftHalfArrow } from "helper/icons";
import { AddHandler } from "shared/Components/addHandler";
import { useMediaQuery } from "react-responsive";
import { DocsSignupMutation } from "redux/features/trialCalendar/trialCalendarGql";
import { client } from "helper/apolloConfig";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { TextButton } from "shared/Components/textButton";

export const DogSignUp = ({ setDogSignup, detail }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const isSmallMobile = useMediaQuery({ query: "(max-width: 630px)" });
  const [signUpDog, setSignUpDog] = useState([
    {
      title: globalVariables.dog,
      dog: "",
      division: "",
      elements: "",
    },
  ]);
  const [currentDog, setCurrentDog] = useState(0);
  const [loading, setLoading] = useState(false);
  const [checkValidation, setCheckValidation] = useState(false);
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });

  const modalRef = useRef();
  const { handleSubmit } = useForm({
    defaultValues: signUpDog[currentDog],
  });

  const onHandleSubmit = () => {
    if (currentDog != null) {
      const dogsData = signUpDog[currentDog];
      // Check for if all 3 null then display validation error else close the accordion
      if (dogsData?.dog && dogsData?.division && dogsData?.elements) {
        setCurrentDog(null);
        setCheckValidation(false);
      } else {
        setCheckValidation(true);
      }
    }
  };

  // Handle Selection of Dropdown
  const onChangeDog = (option, name) => {
    const dogsArr = [...signUpDog];
    if (name) {
      dogsArr[currentDog][name] = option;
    }
    setSignUpDog(dogsArr);
  };

  const onChangeIndex = (index) => {
    setCheckValidation(false);
    setCurrentDog(index);
    // setIsAccordionOpen(index !== null);
  };

  // Add new Dog Data
  const onAddDog = () => {
    setSignUpDog([
      ...signUpDog,
      {
        title: globalVariables.dog,
        dog: "",
        division: "",
        elements: "",
      },
    ]);
    setCurrentDog(signUpDog.length);
    setCheckValidation(false);
  };

  // Submit from Sing up button
  const onGoNext = async () => {
    const newRequestBody = [];
    for (let index = 0; index < signUpDog.length; index++) {
      const { title, ...dog } = signUpDog[index];
      if (!(dog?.dog && dog?.division && dog?.elements)) {
        setCurrentDog(index);
        setCheckValidation(true);
        break;
      }

      newRequestBody.push({
        ...dog,
        elements: dog.elements,
        trialCalendarId: +detail?.id,
      });
    }
    if (newRequestBody?.length > 0 && detail?.id) {
      try {
        setLoading(true);
        await client.mutate({
          mutation: DocsSignupMutation,
          variables: { data: newRequestBody },
        });

        setLoading(false);
        setSignUpDog([
          {
            title: globalVariables.dog,
            dog: "",
            division: "",
            elements: "",
          },
        ]);
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.dogsSignupSuccess,
          desc: globalVariables.dogsSignupSuccessDescription,
          type: "success",
        });
      } catch (error) {
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.error,
          desc: error?.message,
          type: "pending",
        });
        setLoading(false);
      }
    }
  };

  const onGoBack = () => {
    // Put previous screens route
    setDogSignup(false);
  };

  //   Accordion Body card
  const renderAccordionBody = () => {
    return (
      <div>
        <form onSubmit={handleSubmit((d) => console.log({ submitForm: d }))}>
          {dropdowns?.map((dropdown, index) => (
            <>
              <Dropdown
                dropdownOptions={dropdown.options}
                placeholder={dropdown.placeHolder}
                width="w-[100%]"
                dynamicHeight
                checkValidation={checkValidation}
                defaultOption={signUpDog?.[currentDog]?.[dropdown.name]}
                onChange={(value) => onChangeDog(value, dropdown.name)}
                errorMsg={
                  checkValidation && !signUpDog?.[currentDog]?.[dropdown.name]
                    ? dropdown.errorMsg
                    : ""
                }
              />
              {index < dropdowns?.length ? <div className="mt-5" /> : ""}
            </>
          ))}

          <div className="mt-5 flex justify-end">
            <TextButton onClick={onHandleSubmit} label={globalVariables.save} />
          </div>
        </form>
      </div>
    );
  };

  const onCloseModal = () => {
    setCurrentDog(0);
    onGoBack();
  };

  const onRemove = (index) => {
    const dogsArr = [...signUpDog];
    dogsArr.splice(index, 1);
    setSignUpDog(dogsArr);
  };

  return (
    //
    <>
      <div className="pb-20 pt-10 ">
        <div className="flex justify-center lg:justify-start lg:pl-5">
          {!isSmallMobile ? (
            <button onClick={onGoBack}>
              <LeftHalfArrow className="mr-4" />
            </button>
          ) : (
            ""
          )}
          <span className="text-3xl font-semibold text-gray-900">
            {globalVariables.dogSignup}
          </span>
        </div>
        <div className="flex justify-center mt-8 flex-col items-center sm:p-[16px]">
          <span className="text-xl font-semibold text-gray-900 mb-1">
            {globalVariables.dogSignupTitle}
          </span>
          <div className="mt-6" />

          <Accordion
            items={signUpDog}
            children={renderAccordionBody()}
            onChangeIndex={onChangeIndex}
            defaultIndex={currentDog}
            hasRemove
            onRemove={onRemove}
          />
          <AddHandler
            dogSignUp={true}
            onAdd={onAddDog}
            label={globalVariables.addDog}
          />
        </div>
      </div>
      <BottomButtons
        outlineLabel={globalVariables.back}
        fullLabel={globalVariables.signUp}
        onTapYes={onGoNext}
        onTapNo={onGoBack}
        position={"fixed"}
        dogSign={true}
        extraClass={isMobile ? "h-[80px]" : "dog-signup-bb-h"}
        disabled={loading}
      />
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={modalRef}
        onCloseModal={onCloseModal}
      />
    </>
  );
};
